import { ShieldStarIcon } from './ShieldStarIcon';

/**
 * author: Michael Irigoyen
 * id 9C6B0512-02BF-4C33-ADAF-54D75B3AD2FB
 * name shield-star
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-star.svg
 * tags
 */
export const BadgeIcon = ShieldStarIcon;
export default BadgeIcon